





/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATESTAKENOWSECTION
// UPDATESTAKENOWSECTION


const UPDATESTAKENOWSECTION= createAsyncThunk(
  "updateStakeNowSection/updateStakeNowSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateStakeNowSectionSlice = createSlice({
  name: "updateStakeNowSectionSlice",
  initialState: {
    updateStakeNowSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateStakeNowSection: (state) => {
        state.updateStakeNowSection.loading = false
        state.updateStakeNowSection.error = false
        state.updateStakeNowSection.data = []
        state.updateStakeNowSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATESTAKENOWSECTION.fulfilled, (state, action) => {
      state.updateStakeNowSection = {
        ...state.updateStakeNowSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATESTAKENOWSECTION.pending, (state, action) => {
      state.updateStakeNowSection = {
        ...state.updateStakeNowSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATESTAKENOWSECTION.rejected, (state, action) => {
      state.updateStakeNowSection = {
        ...state.updateStakeNowSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateStakeNowSectionAction = {
    UPDATESTAKENOWSECTION,
};

export { updateStakeNowSectionAction };
export default updateStakeNowSectionSlice.reducer;
export const {setInitialStateOfupdateStakeNowSection} = updateStakeNowSectionSlice.actions
